import { search } from './searchService';
import { post, put, del, getById } from './apiService';
import type { RetellCallReport } from '../types/callReport';
import type { SearchParams } from '../types/search';

export async function searchCallReports(
  filter: object = {},
  params: SearchParams = {},
): Promise<RetellCallReport[]> {
  return search<RetellCallReport>('/retell-call-report/search', filter, params);
}

export async function getCallReportById(id: string): Promise<RetellCallReport> {
  return getById<RetellCallReport>('/retell-call-report', id);
}

export async function createCallReport(data: {
  agentId: string;
  name?: string;
  scoreCategories: RetellCallReport['scoreCategories'];
}): Promise<RetellCallReport> {
  return post<RetellCallReport>('/retell-call-report', data);
}

export async function updateCallReport(
  id: string,
  data: RetellCallReport,
): Promise<RetellCallReport> {
  return put<RetellCallReport>(`/retell-call-report/${id}`, data);
}

export async function deleteCallReport(id: string): Promise<void> {
  return del<void>(`/retell-call-report/${id}`);
}
